import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import Input from '@lightspeed/cirrus-input';
import Text from '@lightspeed/cirrus-text';

class VendorReturnAddItem extends Component {
  constructor(props) {
    super(props);

    this.inputRef = React.createRef();
    this.handleInputKeyPress = this.handleInputKeyPress.bind(this);
    this.handleItemAdded = this.handleItemAdded.bind(this);
  }

  componentDidMount() {
    this.initInput();
  }

  initInput() {
    this.inputRef.current.input.classList.add('itembarcode');

    if (!window.isGriffin()) {
      this.inputRef.current.input.focus();
    } else {
      document.activeElement.blur();
    }
  }

  /**
   * Barcode scanning event since form submit is not triggered for some reason.
   * 500ms wait for the digits to be entered in the field before triggering search.
   *
   * @param event
   */
  handleInputKeyPress(event) {
    const { key, keyCode } = event;
    const { onAddItem } = this.props;

    if (key === 'Enter' || keyCode === 13) {
      event.preventDefault();
      window.setTimeout(() => {
        onAddItem({ value: this.inputRef.current.input.value, onDone: this.handleItemAdded });
      }, 500);
    }
  }

  handleItemAdded() {
    if (this.inputRef.current) {
      this.inputRef.current.input.value = '';
      if (!window.isGriffin()) {
        this.inputRef.current.input.focus();
      }
    }
  }

  render() {
    const { isAddingItem, isDisabled } = this.props;

    return (
      <form
        onSubmit={event => {
          event.preventDefault();
          this.props.onAddItem({
            value: this.inputRef.current.input.value,
            onDone: this.handleItemAdded,
          });
        }}
      >
        <Text heading3 className="cr-pb-2">
          Add items
        </Text>
        <Group noSpacing inputBlock className="cr-mb-4">
          <Input
            ref={this.inputRef}
            type="text"
            placeholder="Item search"
            data-test="vendor-return-item-search-input"
            disabled={isDisabled}
            onKeyPress={this.handleInputKeyPress}
          />
          <Button
            variant="secondary"
            fill
            type="submit"
            className="barcodesubmit"
            loading={isAddingItem}
            disabled={isDisabled}
            data-test="vendor-return-item-search-button"
          >
            Add item
          </Button>
        </Group>
      </form>
    );
  }
}

VendorReturnAddItem.propTypes = {
  isAddingItem: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onAddItem: PropTypes.func,
};

export default VendorReturnAddItem;
